<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มผู้ดูแลระบบใหม่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>{{ adminInit.email }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ adminInit.date_start }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">
          สิทธิ์ใช้งานระบบ
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-autocomplete
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="admin.role_uuid"
          :rules="[(v) => !!v || 'โปรดระบุสิทธิ์ใช้งานระบบ']"
          :items="adminRoles"
          item-text="title_th"
          item-value="role_uuid"
          outlined
          dense
        >
        </v-autocomplete>
        <label class="body-2">
          อีเมล
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="admin.email"
          :rules="emailRules"
          required
          clearable
          outlined
          dense
          @change="checkEmpty($event, 'email')"
        >
        </v-text-field>
        <div v-if="formAction === 'add'">
          <label class="body-2">
            รหัสผ่านเริ่มต้น
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            tabindex="3"
            v-model="admin.password"
            :rules="passwordRules"
            type="password"
            required
            clearable
            outlined
            dense
          >
          </v-text-field>
          <label class="body-2">
            ยืนยันรหัสผ่าน
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            tabindex="4"
            v-model="admin.confirmPassword"
            :rules="confirmPasswordRules"
            type="password"
            required
            clearable
            outlined
            dense
          >
          </v-text-field>
        </div>
        <v-switch
          tabindex="5"
          v-model="admin.is_active"
          :label="admin.is_active ? 'เปิดการใช้งาน' : 'ปิดการใช้งาน'"
          :disabled="
            (formAction === 'edit' && user.email === adminInit.email) ||
            (uiCtrl &&
              !uiCtrl.isEnable('btn:::admin:company_admin:is_active:update'))
          "
        ></v-switch>
        <v-dialog
          ref="dialogDateStart"
          v-model="modalDateStart"
          :return-value.sync="admin.date_start"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <div>
              <label class="body-2"> วันเริ่มใช้ </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                tabindex="6"
                :value="adminDateStartFormatted"
                :rules="[ruleDateStart || 'จำเป็นต้องใส่วันที่']"
                append-icon="mdi-calendar"
                @click:append="modalDateStart = true"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="adminClear('date_start')"
                outlined
                dense
              ></v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="admin.date_start"
            scrollable
            locale="th-TH"
            :year-format="yearFormatted"
            :header-date-format="headerDateFormatted"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalDateStart = false"
              >ยกเลิก
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialogDateStart.save(admin.date_start)"
              >ตกลง
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <v-dialog
          ref="dialogTimeStart"
          v-model="modalTimeStart"
          :return-value.sync="admin.time_start"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <div>
              <label class="body-2"> เวลาเริ่มใช้ </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                tabindex="7"
                :value="admin.time_start"
                :rules="[ruleTimeStart || 'จำเป็นต้องใส่เวลา']"
                append-icon="mdi-clock-outline"
                @click:append="modalTimeStart = true"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="adminClear('time_start')"
                outlined
                dense
              ></v-text-field>
            </div>
          </template>
          <v-time-picker
            v-if="modalTimeStart"
            v-model="admin.time_start"
            full-width
            format="24hr"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalTimeStart = false"
              >ยกเลิก
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialogTimeStart.save(admin.time_start)"
              >ตกลง
            </v-btn>
          </v-time-picker>
        </v-dialog>
        <v-dialog
          ref="dialogDateExpire"
          v-model="modalDateExpire"
          :return-value.sync="admin.date_expire"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <div>
              <label class="body-2"> วันหมดอายุ </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                tabindex="8"
                :value="adminDateExpireFormatted"
                :rules="[ruleDateExpire || 'จำเป็นต้องใส่วันที่']"
                append-icon="mdi-calendar"
                @click:append="modalDateExpire = true"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="adminClear('date_expire')"
                outlined
                dense
              ></v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="admin.date_expire"
            scrollable
            locale="th-TH"
            :year-format="yearFormatted"
            :header-date-format="headerDateFormatted"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalDateExpire = false"
              >ยกเลิก
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialogDateExpire.save(admin.date_expire)"
              >ตกลง
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <v-dialog
          ref="dialogTimeExpire"
          v-model="modalTimeExpire"
          :return-value.sync="admin.time_expire"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <div>
              <label class="body-2"> เวลาหมดอายุ </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                tabindex="9"
                :value="admin.time_expire"
                :rules="[ruleTimeExpire || 'จำเป็นต้องใส่เวลา']"
                append-icon="mdi-clock-outline"
                @click:append="modalTimeExpire = true"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="adminClear('time_expire')"
                outlined
                dense
              ></v-text-field>
            </div>
          </template>
          <v-time-picker
            v-if="modalTimeExpire"
            v-model="admin.time_expire"
            full-width
            format="24hr"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalTimeExpire = false"
              >ยกเลิก
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialogTimeExpire.save(admin.time_expire)"
              >ตกลง
            </v-btn>
          </v-time-picker>
        </v-dialog>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isAdminDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::admin:company_admin:delete')
            "
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::admin:company_admin:create')
            "
            tabindex="4"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::admin:company_admin:update')
            "
            tabindex="4"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    admin: {
      type: Object,
    },
    adminInit: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      modalDateStart: false,
      modalDateExpire: false,
      modalTimeStart: false,
      modalTimeExpire: false,
      emailRules: [
        (v) => !!v || 'โปรดระบุอีเมล',
        (v) => /.+@.+\..+/.test(v) || 'อีเมลไม่ถูกต้อง',
      ],
      passwordRules: [
        (v) => !!v || 'โปรดระบุรหัสผ่าน',
        (v) =>
          (v && v.length >= 8 && v.length <= 128) ||
          'รหัสผ่านต้องอยู่ระหว่าง 8 ถึง 128 ตัวอักษร',
      ],
      confirmPasswordRules: [
        (v) => v === this.admin.password || 'ยืนยันรหัสผ่านไม่ถูกต้อง',
      ],
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    ruleDateStart() {
      if (this.admin.time_start && !this.admin.date_start) return false
      return true
    },
    ruleTimeStart() {
      if (this.admin.date_start && !this.admin.time_start) return false
      return true
    },
    ruleDateExpire() {
      if (this.admin.time_expire && !this.admin.date_expire) return false
      return true
    },
    ruleTimeExpire() {
      if (this.admin.date_expire && !this.admin.time_expire) return false
      return true
    },
    adminDateStartFormatted() {
      return this.admin.date_start
        ? moment(this.admin.date_start).format('DD/MM/YYYY')
        : ''
    },
    adminDateExpireFormatted() {
      return this.admin.date_expire
        ? moment(this.admin.date_expire).format('DD/MM/YYYY')
        : ''
    },
    isAdminDataChange() {
      if (
        this.admin.role_uuid !== this.adminInit.role_uuid ||
        this.admin.email !== this.adminInit.email ||
        this.admin.is_active !== this.adminInit.is_active ||
        this.admin.date_start !== this.adminInit.date_start ||
        this.admin.time_start !== this.adminInit.time_start ||
        this.admin.date_expire !== this.adminInit.date_expire ||
        this.admin.time_expire !== this.adminInit.time_expire
      ) {
        this.$emit('isAdminDataChange', true)
        return true
      }
      this.$emit('isAdminDataChange', false)
      return false
    },
    adminRoles() {
      return this.$store.state.role.roles
    },
    user() {
      return this.$store.state.authentication.user || {}
    },
  },
  methods: {
    ...mapActions({
      addAdmin: 'admin/addAdmin',
      editAdmin: 'admin/editAdmin',
      deleteAdmin: 'admin/deleteAdmin',
    }),
    adminClear(field) {
      this.admin[field] = undefined
    },
    yearFormatted(year) {
      return `ค.ศ. ${year}`
    },
    headerDateFormatted(date) {
      // use momentjs
      return moment(date).locale('th').format('MMMM YYYY')

      // not use library
      // const monthsOfYear = [
      //   'มกราคม',
      //   'กุมภาพันธ์',
      //   'มีนาคม',
      //   'เมษายน',
      //   'พฤษภาคม',
      //   'มิถุนายน',
      //   'กรกฎาคม',
      //   'สิงหาคม',
      //   'กันยายน',
      //   'ตุลาคม',
      //   'พฤศจิกายน',
      //   'ธันวาคม'
      // ]
      // let i = new Date(date).getMonth(date)
      // return `${monthsOfYear[i]} ${date.split('-')[0]}`
    },
    checkEmpty(value, field) {
      if (value) {
        this.admin[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบผู้ดูแลระบบ',
        value: this.admin.email,
        item: this.admin,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(admin) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.deleteAdmin({
        companyUUID: company_uuid,
        companyAdminUUID: admin.company_admin_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)
          // this.$refs.form.reset()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const newAdmin = {
          company_uuid,
          role_uuid: this.admin.role_uuid,
          email: this.admin.email,
          password: this.admin.password,
          is_active: this.admin.is_active,
          start_time:
            this.admin.date_start && this.admin.time_start
              ? moment
                  .utc(`${this.admin.date_start} ${this.admin.time_start}`)
                  .format()
              : null,
          expire_time:
            this.admin.date_expire && this.admin.time_expire
              ? moment
                  .utc(`${this.admin.date_expire} ${this.admin.time_expire}`)
                  .format()
              : null,
        }

        this.addAdmin({
          companyUUID: company_uuid,
          admin: newAdmin,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.admin.date_start = undefined
            this.admin.date_expire = undefined
            this.admin.time_start = undefined
            this.admin.time_expire = undefined

            this.$refs.form.resetValidation()
            this.$emit('formActionCompleted', this.formAction)
            // this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const adminUpdate = {
          company_uuid,
          company_admin_id: this.admin.company_admin_id,
          role_uuid: this.admin.role_uuid,
          email: this.admin.email,
          is_active: this.admin.is_active,
          start_time:
            this.admin.date_start && this.admin.time_start
              ? moment
                  .utc(`${this.admin.date_start} ${this.admin.time_start}`)
                  .format()
              : null,
          expire_time:
            this.admin.date_expire && this.admin.time_expire
              ? moment
                  .utc(`${this.admin.date_expire} ${this.admin.time_expire}`)
                  .format()
              : null,
        }

        this.editAdmin({
          companyUUID: company_uuid,
          companyAdminUUID: this.admin.company_admin_uuid,
          admin: adminUpdate,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$refs.form.resetValidation()
            this.$emit('formActionCompleted', this.formAction)
            // this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isAdminDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.form.resetValidation()
        this.$emit('formActionCompleted', this.formAction)
        // this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.admin.date_start = undefined
      this.admin.date_expire = undefined
      this.admin.time_start = undefined
      this.admin.time_expire = undefined

      this.$refs.form.resetValidation()
      this.$emit('formActionCompleted', this.formAction)
      // this.$refs.form.reset()
    },
    onReset() {
      if (this.formAction === 'add' || this.formAction === '') {
        this.admin.date_start = undefined
        this.admin.date_expire = undefined
        this.admin.time_start = undefined
        this.admin.time_expire = undefined

        this.$refs.form.resetValidation()
        // this.$refs.form.reset()
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>
